import { Calendar, Clock, User } from 'lucide-react';
import { ElementType, FC } from 'react';

export interface DetailsProps {
  createdBy: string;
  createdDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
}

export const Details: FC<DetailsProps> = ({
  createdBy,
  createdDate,
  lastModifiedDate,
  lastModifiedBy,
}) => {
  return (
    <div>
      <div className="space-y-2 mb-4 text-xs text-gray-500">
        <DetailsParagraph prefix="Created by" text={createdBy} Icon={User} />
        <DetailsParagraph prefix="Created on" text={createdDate} Icon={Calendar} />
      </div>
      <div className="space-y-2 mb-4 text-xs text-gray-500">
        <DetailsParagraph prefix="Modified by" text={lastModifiedBy} Icon={User} />
        <DetailsParagraph prefix="Mdified on" text={lastModifiedDate} Icon={Clock} />
      </div>
    </div>
  );
};

interface DetailsParagraphProps {
  text: string;
  prefix: string;
  Icon: ElementType;
}

export const DetailsParagraph: FC<DetailsParagraphProps> = ({ text, prefix, Icon }) => {
  return (
    <div className="flex items-center space-x-2">
      <Icon className="w-3 h-3" />
      <span>
        {prefix} {text}
      </span>
    </div>
  );
};
